var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 63.991,
    height: 88.336,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 91 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer_x0020_1",
    fill: "none",
    stroke: "#999",
    strokeWidth: 0.948407,
    d: "M28 126c5-10 8-11 8-15 0-3 1-8-5-19-6-1-14 3-19 0-1-1 0-5 0-8-1-1-2-1-2-2s1-3 0-4c0-1-4-2-3-3 1-2 0-6 0-6-2-1-6 1-7-1 1-8 8-13 7-18 0-1 0-4-1-5-3 1 0-12 0-13 0-2-4-4-3-7 3-6 5-10 9-12 5-3 10-6 14-8 9-5 16-6 30-3 8 2 6 2 12 5 23 13 18 36 17 52-3 5-4 12-8 13-6 3-8 3-11 9-1 5-1 5 5 15 4 5 6 6 9 9s7 12 11 21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarLeft);
export default __webpack_public_path__ + "static/media/AvatarLeft.0c447257fa59efabbf11438517f6f91d.svg";
export { ForwardRef as ReactComponent };